/* ============================================================
   outofspaces® — Scroll Animations & Interactions
   Vanilla JS, no dependencies
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── 1. SCROLL REVEAL ─────────────────────────────────────
     Add class="oos-reveal" to any element to fade+slide it in
     on scroll. Add data-delay="100" for stagger (ms).
  ──────────────────────────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.oos-reveal');

  if (revealEls.length) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const el = entry.target;
            const delay = el.dataset.delay || 0;
            setTimeout(function () {
              el.classList.add('oos-revealed');
            }, parseInt(delay));
            revealObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ── 2. STAGGER CHILDREN ──────────────────────────────────
     Add class="oos-stagger" to a parent — each direct child
     gets .oos-reveal with auto-incrementing delay.
  ──────────────────────────────────────────────────────────── */
  document.querySelectorAll('.oos-stagger').forEach(function (parent) {
    Array.from(parent.children).forEach(function (child, i) {
      child.classList.add('oos-reveal');
      child.dataset.delay = i * 80;
    });
  });

  /* Re-run reveal observer for stagger children */
  document.querySelectorAll('.oos-stagger .oos-reveal').forEach(function (el) {
    const staggerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay || 0;
            setTimeout(function () {
              entry.target.classList.add('oos-revealed');
            }, parseInt(delay));
            staggerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    staggerObserver.observe(el);
  });

  /* ── 3. SMOOTH SCROLL for anchor links ───────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── 5. INTRO SPLASH ────────────────────────────────────── */
  var intro = document.getElementById('oos-intro');
  var banner = document.querySelector('.oos-brand-banner__text');

  function dismissIntro() {
    if (!intro) return;
    intro.style.animation = 'introExit 0.5s cubic-bezier(0.4, 0, 1, 1) forwards';
    if (banner) banner.style.animationDelay = '0s';
    setTimeout(function () { intro.classList.add('oos-intro--gone'); }, 520);
  }

  if (intro) {
    if (sessionStorage.getItem('oos-intro-seen')) {
      /* Already seen — skip instantly */
      intro.classList.add('oos-intro--gone');
      if (banner) banner.style.animationDelay = '0s';
    } else {
      sessionStorage.setItem('oos-intro-seen', '1');
      /* CSS auto-dismisses after 1.6s hold + 0.8s fade */
      /* Skip button */
      var skipBtn = document.getElementById('oos-intro-skip');
      if (skipBtn) skipBtn.addEventListener('click', dismissIntro);
    }
  } else if (banner) {
    banner.style.animationDelay = '0s';
  }

  /* ── 6. PROCESS ACCORDION ────────────────────────────────── */
  document.querySelectorAll('.oos-process__row').forEach(function (row) {
    row.addEventListener('click', function () {
      const isOpen = this.classList.contains('is-open');
      document.querySelectorAll('.oos-process__row').forEach(function (r) {
        r.classList.remove('is-open');
      });
      if (!isOpen) this.classList.add('is-open');
    });
  });

  /* ── 6. NAV SCROLL BEHAVIOUR (transparent → solid) ──────── */
  var nav = document.getElementById('oos-nav');
  if (nav && document.body.classList.contains('template-index')) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('is-solid', window.scrollY > 80);
    }, { passive: true });
  }

});
